const Joi = require('joi')
const paginationSchema = require('../queries/pagination.validator');
const filterSchema = require('../queries/checkoutTransactionFilters.validator');

const getCheckoutTransactionsSchema = Joi.object({
    filters: filterSchema,
    paging: paginationSchema.required(),
})

module.exports = getCheckoutTransactionsSchema